import { MDBIcon } from "mdb-react-ui-kit";
import { useContext } from 'react';
import useResumeBusinessSkillsHandlers from "../../../../context/resume/hooks/resume-business-skills-handlers";
import { TranslationContext } from "../../../../context/translations/translations-context";

export default function AddCompetence( { parentOrder } ) {
    const { translations } = useContext( TranslationContext );
    const { handleAddCompetence } = useResumeBusinessSkillsHandlers();

    const emptyCompetence = {
        order: -1,
        id: null,
        translations: { 'en': '', 'fr': '' },
        level: 0
    };

    return (
        <button className="btn_primary" onClick={ () => handleAddCompetence( emptyCompetence, parentOrder ) }>
            <MDBIcon fas icon="plus-circle"
                     size='sm'
                     color='light'
                     title={ translations.businessSkillsSection.addCompetenceLabel }
            />
            <span className='ms-1'>{ translations.businessSkillsSection.addCompetenceLabel }</span>
        </button>
    )
}
